import { z } from 'zod';
/**
 * Schemas + DTOs für das Skill `ai-field-prefill` (Paket E, Issue #80).
 *
 * Domänen-Modell:
 *  - Ein `FieldSource` ist die Provenienz-Spur pro Projekt + Feld.
 *  - Der Prefill-Skill erzeugt FieldSources mit status=`proposed_ai`.
 *  - Akzeptiert der User, wird das Projekt-Feld gesetzt und der Status auf
 *    `accepted` (Wert unverändert) bzw. `modified` (Wert geändert) gesetzt.
 *  - Lehnt der User ab, wird der Status auf `rejected` gesetzt — das
 *    Projekt-Feld bleibt unangetastet.
 */
// Lokale Mirror-Enums für strikte Validierung im FE (Prisma hält die Wahrheit, hier nur DTO).
export const fieldStatus = z.enum([
    'proposed_ai',
    'proposed_clone',
    'proposed_input',
    'proposed_legal',
    'accepted',
    'modified',
    'manual',
    'rejected',
]);
export const fieldSourceKind = z.enum([
    'ai_inference',
    'legal_rule',
    'customer_data',
    'prior_project',
    'clone',
    'input_artifact',
    'manual',
]);
export const prefillFieldRequest = z
    .object({
    value: z.unknown().optional(),
    /**
     * Bestätigung, dass ein Vorschlag mit niedriger Confidence bewusst
     * übernommen wird.
     *
     * Ohne dieses Flag lehnt das API die Übernahme unterhalb der konfigurierten
     * Schwelle ab. Grund: sobald ein Wert akzeptiert ist, zählt er in der
     * Vollständigkeitsberechnung als „menschlich entschieden" und ist im
     * Dokument von einem geprüften Wert nicht mehr zu unterscheiden. Ein Klick
     * darf eine Vermutung nicht unbemerkt in ein Faktum verwandeln.
     */
    acknowledgeLowConfidence: z.boolean().optional(),
})
    .strict();
